<template>
  <div :class="wrapBgColor" class="info-box">
    <span class="info-box-icon" v-bind:class="bgColor">
      <i v-bind:class="bgIcon"></i>
    </span>
    <div class="info-box-content">
      <span class="info-box-text">{{ text }}</span>
      <span class="info-box-number">
        <span v-if="subText">{{ subText }}</span>
        <span v-else>{{ parseNumber }}</span>
      </span>

      <div v-if="isProgress" class="progress">
        <div :style="`width: ${percentage}%`" class="progress-bar"></div>
      </div>
      <span class="progress-description">
        {{ progressDescription }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'va-info-box',
  props: {
    wrapBgColor: {
      type: String
    },
    bgColor: {
      type: String
    },
    bgIcon: {
      type: String
    },
    text: {
      type: String,
      required: true
    },
    number: {
      type: Number,
      default: 0
    },
    subText: {
      type: String,
      default: ''
    },
    numberType: {
      type: String
    },
    percentage: {
      type: Number,
      default: 0
    },
    progressDescription: {
      type: String,
      default: ''
    },
    isProgress: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    parseNumber() {
      let result = this.number
      switch (this.numberType) {
        case 'percentage':
          result += '%'
          break
        case 'comma':
          result = Number(result).toLocaleString('en')
          break
        default:
          break
      }
      return result
    }
  }
}
</script>

<style></style>
